/**
 * The backend stores `type` as a CharField with no choices and no validation, so
 * a value no client sends today can still be persisted and served back.
 * Never narrow reaction type to a union or switch exhaustively on it.
 */
export const DISCUSSION_REACTION_LIKE = 'like'
